<template>
    <div class="footer mt100">
        <div class="content-footer">
            <div class="fw400 fs18 pb8">레인보우 TV</div>
            <div class="text-content pb24">
                (주)씨엠비 대표자 이한담 <span class="text-content fs12 underline" @click="openFairTradeCommission">사업자등록번호 305-81-46536</span><br>
                우편번호 34830 대전광역시 중구 우암로 1 <br>
                이메일 kangsinwan@cmb.co.kr
            </div>
            <div>
                <span class="text-content fs14 pb8 underline pr4" @click="moveConfig('service')">이용약관</span>
                <span class="text-content fs16 gray pb8 pr4">/</span>
                <span class="text-content fs16 blue pb8 underline" @click="moveConfig('privacy')">개인정보처리방침</span>
            </div>
            <div class="text-content black pb4">
                통신판매업 번호 제2010-대전중구-0048호
            </div>
            <div class="text-content fs12">
                CMB 대전방송, CMB 동대전방송, CMB 세종방송, CMB 충청방송, CMB 광주방송, CMB 광주동부방송, CMB 전남방송, CMB 대구방송, CMB 수성방송, CMB 영등포방송,
                CMB
                동대문방송<br>[고객행복센터 ARS 안내] 대표전화: 1544-3434(유료/자사인터넷전화가입자 무료)
            </div>
        </div>
    </div>
</template>

<script>
//
export default {
    name: "PageFooter",
    mixins: [],
    components: {},
    inject: [],
    provide() {
        return {}
    },
    props: {},
    data() {
        return {}
    },
    beforeRouterEnter() {
    },
    created() {
    },
    mounted() {
    },
    beforeDestroy() {
    },
    destroyed() {
    },
    computed: {},
    methods: {
        moveConfig(tab) {
            this.$router.push({
                path: '/config',
                query: {tab},
            });
        },
        openFairTradeCommission() {
            window.open('https://www.ftc.go.kr/www/biz/bizCommList.do?key=5375', '_blank');
        },
    },
    watch: {},
}
</script>
<style lang="scss"></style>
